export default "__VITE_ASSET__BEicHJ2L__"